import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
const { EleResize } = require('@/assets/js/eresize.js');
class UserForm extends CBcDialogForm {
    constructor(form) {
        super();
        const that = this;
        if (form) {
            Object.keys(form).forEach((k) => {
                that[k] = form[k];
            });
        }
    }
}
var EDeviceType;
(function (EDeviceType) {
    EDeviceType["All"] = "";
    EDeviceType["Xilin"] = "xilin";
    EDeviceType["Ampul"] = "ampul";
    EDeviceType["Auto"] = "auto";
})(EDeviceType || (EDeviceType = {}));
let StatisticDispense = class StatisticDispense extends Vue {
    constructor() {
        super();
        this.pageLoading = {
            total: {
                months: false,
                device: false,
            },
            xilin: {
                months: false,
                locate: false,
                hospital: false,
                device: false,
            },
            ampul: {
                months: false,
                locate: false,
                hospital: false,
                device: false,
            },
            comp: {
                months: false,
                locate: false,
                hospital: false,
                device: false,
            }
        };
        this.display = {
            xilin: true,
            ampul: true,
            comp: false
        };
        this.dialog = new CBcDialog(new UserForm());
        this.dispenSyncTableOptions = {
            visible: false,
            pageSize: 10,
            page: 1,
            total: 1,
            expanded: []
        };
        this.dispenSyncPageLoading = false;
        this.dispenSyncList = [];
        this.dispenSyncHeaders = [
            { text: '设备名称', align: 'center', width: 120, value: 'deviceName' },
            { text: '设备编号', align: 'center', width: 100, value: 'deviceNo' },
            { text: '设备型号', align: 'center', width: 100, value: 'deviceMode' },
            { text: '开始日期', align: 'center', width: 100, value: 'startDate' },
            { text: '最后日期', align: 'center', width: 100, value: 'lastDate' },
            { text: '相差天数', align: 'center', width: 100, value: 'datediff' },
            { text: '医院名称', align: 'center', minWidth: 100, value: 'hospital' },
            { text: '记录人员', align: 'center', width: 100, value: 'recorder' },
            { text: '配药总数', align: 'center', width: 110, value: 'total' },
            { text: '成功总数', align: 'center', width: 100, value: 'success' },
            { text: '失败总数', align: 'center', width: 100, value: 'fails' },
            { text: '药瓶总数', align: 'center', width: 100, value: 'bottles' },
            { text: '成功率', align: 'center', width: 90, value: 'rate' },
        ];
        this.snackbar = new CBcSnackbar();
        this.disMonthsOp = ['all', 'xilin', 'ampul', 'auto']
            .map((v, i) => ({ dataType: v,
            title: {
                show: false,
                textStyle: {
                    color: '#bcbcbc'
                },
                text: '没有数据',
                left: 'center',
                top: 'center',
            },
            color: ['#5793f3', '#d14a61', '#675bba'],
            tooltip: {
                trigger: 'axis'
            },
            toolbox: {
                feature: {
                    dataView: { show: true, readOnly: false },
                    restore: { show: true },
                    saveAsImage: {}
                }
            },
            dataZoom: [
                {
                    show: true,
                    realtime: true,
                },
                {
                    type: 'inside',
                    realtime: true,
                }
            ], xAxis: {
                type: 'category',
                axisTick: {
                    alignWithLabel: true
                },
                axisLine: {
                    lineStyle: {
                        color: '#5793f3'
                    }
                },
                axisPointer: {
                    label: {
                        formatter: (params) => `月份: ${params.value}`
                    }
                },
                data: []
            }, yAxis: [
                {
                    name: '成功率(%)',
                    position: 'left',
                    silent: false,
                    splitLine: {
                        show: false
                    },
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }
            ], series: [
                {
                    data: [],
                    name: '成功率',
                    stack: '成功率',
                    type: 'line',
                    smooth: true,
                    animationDelay: (idx) => idx * 10,
                },
                {
                    type: 'bar',
                    barWidth: 1,
                    data: [],
                    itemStyle: {
                        normal: {
                            shadowBlur: 1,
                            color: (params) => {
                                const indexColor = params.value;
                                if (indexColor >= 99) {
                                    return '#45ef96';
                                }
                                else if (indexColor >= 90) {
                                    return '#ffed8b';
                                }
                                else {
                                    return '#ffb8af';
                                }
                            }
                        }
                    },
                    animationDelay: (idx) => idx * 10 + 100
                }
            ], animationEasing: 'elasticOut', animationDelayUpdate: (idx) => idx * 5, sourceData: [] }));
        this.disLocateOp = ['xilin', 'ampul', 'auto']
            .map((v, i) => ({ dataType: v,
            title: {
                show: false,
                textStyle: {
                    color: '#bcbcbc'
                },
                text: '没有数据',
                left: 'center',
                top: 'center',
            },
            color: ['#61a0a8', '#ff7f50', '#87cefa', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'], tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#5793f3'
                    }
                },
                formatter: (datas) => {
                    let res = datas[0].name + '<br/>';
                    /* eslint no-shadow: "off", prefer-destructuring: "off" */
                    for (let i = 0, length = datas.length; i < length; i += 1) {
                        res += datas[i].seriesName + '：'
                            + datas[i].value + `${i === 0 ? '' : '%'}<br/>`;
                    }
                    return res;
                }
            }, toolbox: {
                feature: {
                    dataView: { show: true, readOnly: false },
                    restore: { show: true },
                    saveAsImage: {}
                }
            }, xAxis: {
                type: 'category',
                axisTick: {
                    alignWithLabel: true
                },
                axisLine: {
                    lineStyle: {
                        color: '#5793f3'
                    }
                },
                axisPointer: {
                    label: {
                        formatter: (params) => `${params.value}`
                    }
                },
                data: []
            }, yAxis: [
                {
                    name: '调配总数',
                    position: 'left',
                    silent: false,
                    splitLine: {
                        show: false
                    },
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    }
                }
            ], series: [
                {
                    data: [],
                    name: '调配总数',
                    type: 'bar',
                    barMaxWidth: '40',
                    smooth: true,
                    animationDelay: (idx) => idx * 10,
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                position: 'top',
                            }
                        }
                    }
                }
            ], animationEasing: 'elasticOut', animationDelayUpdate: (idx) => idx * 5, sourceData: [] }));
        this.disDeviceOp = ['xilin', 'ampul', 'auto']
            .map((v, i) => ({ dataType: v,
            title: {
                show: false,
                textStyle: {
                    color: '#bcbcbc'
                },
                text: '没有数据',
                left: 'center',
                top: 'center',
            },
            color: ['#67aeff', '#ff7f50', '#61a0a8', '#d48265', '#91c7ae', '#87cefa', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'], tooltip: {
                trigger: 'axis',
                formatter: (datas) => {
                    let res = datas[0].name + '<br/>';
                    /* eslint no-shadow: "off", prefer-destructuring: "off" */
                    for (let i = 0, length = datas.length; i < length; i += 1) {
                        res += datas[i].seriesName + '：'
                            + datas[i].value + `${i === 0 ? '' : '%'}<br/>`;
                    }
                    return res;
                }
            }, toolbox: {
                feature: {
                    dataView: { show: true, readOnly: false },
                    restore: { show: true },
                    saveAsImage: {}
                }
            }, xAxis: {
                type: 'category',
                axisLabel: {
                    interval: 0,
                    formatter: (value) => `${value}#`
                },
                axisTick: {
                    alignWithLabel: true
                },
                axisLine: {
                    lineStyle: {
                        color: '#5793f3'
                    }
                },
                axisPointer: {
                    label: {
                        formatter: (params) => `${i === 0 ? '西林设备' : i === 0 ? '安瓿设备' : '综合设备'}${params.value}#`
                    }
                },
                data: []
            }, yAxis: [
                {
                    name: '调配总数',
                    position: 'left',
                    silent: false,
                    splitLine: {
                        show: false
                    },
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    }
                }
            ], series: [
                {
                    data: [],
                    name: '调配总数',
                    type: 'bar',
                    barMaxWidth: '40',
                    smooth: true,
                    animationDelay: (idx) => idx * 10,
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                position: 'top',
                                textStyle: {
                                    color: '#3873ff'
                                }
                            }
                        }
                    }
                }
            ], animationEasing: 'elasticOut', animationDelayUpdate: (idx) => idx * 5, sourceData: [] }));
        this.disTotalDeviceTypeOp = {
            color: ['#5470C6', '#FC8452', '#EE6666', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
            backgroundColor: 'rgba(99,154,204, 0.5)',
            title: {
                show: false,
                text: '',
                left: 'center',
                top: 20,
            },
            tooltip: {
                trigger: 'item',
                // formatter: '{a} <br/>{b} : {c}付 ({d}%)'
                formatter: (v) => `${v.name}:(${v.data.rate}%)\n 总数：${v.value} \n 成功数：${v.data.success}`,
            },
            // visualMap: {
            //   show: false,
            //   min: 80,
            //   max: 600,
            //   // inRange: {
            //   //   colorLightness: [0, 1]
            //   // }
            // },
            calculable: true,
            series: [
                {
                    name: '调配设备',
                    type: 'pie',
                    radius: [20, 110],
                    roseType: 'area',
                    center: ['50%', '50%'],
                    data: [],
                    label: {
                        normal: {
                            formatter: (v) => `${v.name}:(${v.data.rate}%)\n 总数：${v.value} \n 成功：${v.data.success}`,
                        }
                    },
                    labelLine: {
                        normal: {
                            lineStyle: {
                                color: 'rgba(255, 255, 255, 0.3)'
                            },
                            smooth: 0.2,
                            length: 10,
                            length2: 20
                        }
                    },
                    itemStyle: {
                        normal: {
                            // color: '#c23531',
                            shadowBlur: 200,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: (idx) => Math.random() * 200
                }
            ]
        };
        const that = this;
    }
    mounted() {
        const that = this;
        that.refreshAll();
    }
    refreshAll() {
        const that = this;
        that.getDispenseSyncRecords();
        that.getMonthsData(EDeviceType.All);
        that.getDisTotalDeviceType();
        that.getMonthsData(EDeviceType.Xilin);
        that.getMonthsData(EDeviceType.Ampul);
        that.getLocateData(EDeviceType.Xilin);
        that.getLocateData(EDeviceType.Ampul);
        that.getDeviceData(EDeviceType.Xilin);
        that.getDeviceData(EDeviceType.Ampul);
    }
    drawLine(dom, option) {
        const that = this;
        const doc = document;
        const eleResize = EleResize;
        const myChart = that.$echarts.init(doc.getElementById(dom));
        const resizeDiv = doc.getElementById(dom);
        // 绘制图表
        myChart.setOption(option);
        eleResize.on(resizeDiv, () => myChart.resize());
    }
    async getDispenseSyncRecords(op) {
        const that = this;
        const params = {};
        that.dispenSyncPageLoading = true;
        that.axios.get('/api/report/dispense/sync', { params: {} }).then((resd) => {
            that.dispenSyncPageLoading = false;
            that.dispenSyncList = (resd && resd.data && resd.data.result || []);
        }).catch((e) => {
            that.dispenSyncPageLoading = false;
        });
    }
    async getDispenseSummary(op) {
        const that = this;
        const params = {};
        // ['台式西林设备', '台式安瓿设备', '综合配药设备']
        if (op && op.deviceType)
            params['deviceType'] = /西林|xilin/i.test(op.deviceType) ? '台式西林设备' : /安瓿|ampul/i.test(op.deviceType) ? '台式安瓿设备' : '综合配药设备';
        if (op && op.group)
            params['group'] = op.group;
        const resd = await that.axios.get('/api/report/dispense/summary', { params: params });
        return resd && resd.data || { result: [] };
    }
    getDeviceTypeKey(deviceType) {
        return deviceType === EDeviceType.Xilin ? '台式西林设备' : deviceType === EDeviceType.Ampul ? '台式安瓿设备' : deviceType === EDeviceType.Auto ? '综合配药设备' : '';
    }
    async handleChartsData(op) {
        const that = this;
        let pageLoadingKey = 'total';
        let groupKey = 'months';
        try {
            const type = op && op.type; // 'rate', 'num'
            const deviceType = op && op.deviceType;
            const displayLineRateOfNumBar = /true/i.test(op && op.lineAndBar);
            const group = op && op.group;
            const isRateType = /rate/i.test(type);
            const isHospitalGroup = /hospital/i.test(group);
            const isDeviceGroup = /device/i.test(group);
            const isXilinType = /西林|xilin/i.test(deviceType);
            const isAmpulType = /安瓿|ampul/i.test(deviceType);
            const isAutoType = /综合|auto/i.test(deviceType);
            const yKey = isRateType ? 'rate' : 'total';
            const xKey = isHospitalGroup ? 'hospital' : isDeviceGroup ? 'device' : 'date';
            let dataTypeIndex = isXilinType ? 1 : isAmpulType ? 2 : isAutoType ? 3 : 0;
            if (isDeviceGroup || isHospitalGroup && dataTypeIndex > 0)
                dataTypeIndex -= 1;
            pageLoadingKey = isXilinType ? 'xilin' : isAmpulType ? 'ampul' : isAutoType ? 'auto' : 'total';
            groupKey = isDeviceGroup ? 'device' : isHospitalGroup ? 'hospital' : 'months';
            const domKey = `chart_dispense_${isXilinType ? 'xilin' : isAmpulType ? 'ampul' : isAutoType ? 'auto' : 'total'}_${groupKey}`;
            const typeKey = isHospitalGroup ? 'disLocateOp' : isDeviceGroup ? 'disDeviceOp' : 'disMonthsOp';
            that.pageLoading[pageLoadingKey][groupKey] = true;
            const res = await that.getDispenseSummary(op);
            that[typeKey][dataTypeIndex]['sourceData'] = res.result.map((v) => v[yKey]);
            that[typeKey][dataTypeIndex]['series'][0]['data'] = that[typeKey][dataTypeIndex]['sourceData'];
            if (displayLineRateOfNumBar) {
                that[typeKey][dataTypeIndex]['yAxis'][1] = { type: 'value', name: '成功率', min: 0, max: 100, axisLabel: { formatter: '{value}%' } };
                that[typeKey][dataTypeIndex]['series'][1] = {
                    data: [],
                    name: '成功率',
                    stack: '成功率',
                    type: 'line',
                    smooth: true,
                    yAxisIndex: 1,
                    animationDelay: (idx) => idx * 10,
                    itemStyle: { normal: { label: { show: true, position: 'top', } } },
                    label: {
                        normal: {
                            formatter: (params) => (`{${params.value > 99 ? 'a' : params.value > 90 ? 'b' : 'c'}|${params.value}%}`),
                            rich: {
                                a: { color: 'green' },
                                b: { color: '#ffb8af' },
                                c: { color: 'red' },
                            }
                        }
                    },
                };
            }
            if (isRateType || displayLineRateOfNumBar)
                that[typeKey][dataTypeIndex]['series'][1]['data'] = displayLineRateOfNumBar ? res.result.map((v) => v['rate']) : that[typeKey][dataTypeIndex]['sourceData'];
            that[typeKey][dataTypeIndex]['xAxis']['data'] = res.result.map((v) => v[xKey]);
            that.pageLoading[pageLoadingKey][groupKey] = false;
            // console.log('data:', that[typeKey][dataTypeIndex]['sourceData'], ',type:', typeKey, ',dtaaType:', dataTypeIndex, ',x:', that[typeKey][dataTypeIndex]['xAxis']['data'])
            if (that[typeKey][dataTypeIndex]['sourceData'].length)
                that.$nextTick(() => that.drawLine(domKey, that[typeKey][dataTypeIndex]));
        }
        catch (e) {
            that.pageLoading[pageLoadingKey][groupKey] = false;
            console.log('error of get handleChartsData months.', e);
            that.snackbar.error('处理汇总数据过程出错:' + e.toString());
        }
    }
    async getMonthsData(deviceType) {
        const that = this;
        try {
            await that.handleChartsData({ type: 'rate', deviceType: that.getDeviceTypeKey(deviceType) });
        }
        catch (e) {
            console.log('error of get dispense summary months.', e);
            that.snackbar.error('加载月配药汇总数据过程出错');
        }
    }
    async getLocateData(deviceType) {
        const that = this;
        try {
            await that.handleChartsData({ type: 'num', deviceType: that.getDeviceTypeKey(deviceType), group: 'hospital', lineAndBar: true });
        }
        catch (e) {
            console.log('error of get dispense summary hospital.', e);
            that.snackbar.error('加载各地配药汇总数据过程出错');
        }
    }
    async getDeviceData(deviceType) {
        const that = this;
        try {
            await that.handleChartsData({ type: 'num', deviceType: that.getDeviceTypeKey(deviceType), group: 'device', lineAndBar: true });
        }
        catch (e) {
            console.log('error of get dispense summary device.', e);
            that.snackbar.error('加载各机器配药汇总数据过程出错');
        }
    }
    async getDisTotalDeviceType() {
        const that = this;
        try {
            that.pageLoading.total.device = true;
            const params = {};
            const resd = await that.axios.get('/api/report/dispense/devicetype');
            const res = resd && resd.data || { result: [] };
            that.disTotalDeviceTypeOp['sourceData'] = res.result.map((v) => ({ ...v, value: v.total, name: v.deviceType }));
            that.disTotalDeviceTypeOp['series'][0]['data'] = that.disTotalDeviceTypeOp['sourceData'];
            that.pageLoading.total.device = false;
            if (that.disTotalDeviceTypeOp['sourceData'].length)
                that.$nextTick(() => that.drawLine('chart_dispense_total_device', that.disTotalDeviceTypeOp));
        }
        catch (e) {
            that.pageLoading.total.device = false;
            console.log('error of get dispense summary device.', e);
            that.snackbar.error('加载各机器配药汇总数据过程出错');
        }
    }
};
__decorate([
    Getter
], StatisticDispense.prototype, "userInfo", void 0);
StatisticDispense = __decorate([
    Component({
        name: 'StatisticDispense',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], StatisticDispense);
export default StatisticDispense;
;
